import React from "react";
import { useCart } from "../../Client/context/CartContext"; // Importar el contexto del carrito
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const { addToCart } = useCart(); // Función para añadir al carrito
  const price = parseFloat(product.price).toFixed(2); // Asegura que el precio sea numérico

  return (
    <div className="product-card">
      <img src={product.image} alt={product.name} />
      <h3>{product.name}</h3>
      <p className="product-category">Categoría: {product.category}</p>
      <p className="product-price">${price}</p>
      <button className="add-to-cart-btn" onClick={() => addToCart(product)}>
        Añadir al carrito
      </button>
    </div>
  );
};

export default ProductCard;
